// EditStudent Component for update student data

// Import Modules
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useOutletContext } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import PatientKulawruttaForm from "../Forms/PatientKulawruttaForm";
import CONFIG from "../../config";
import { usePatient } from "../../context/PatientContext";
import { useAuth } from "../../context/AuthProvider";

// EditStudent Component
const EditPatientKulawrutta = () => {
  const { markSectionComplete } = useOutletContext();
  const navigate = useNavigate();
  const { verifyTokenAndRedirect } = useAuth();
  const { patientData, setPatientData, selectedCase, doctorInfo } =
    usePatient();
  const { patientId, caseId, visitId } = useParams();
  const location = useLocation();

  useEffect(() => {
    verifyTokenAndRedirect();
  }, []);

  //onSubmit handler
  const onSubmitHandler = (updatedPatientKulawrutta) => {
    console.log("patient data after submit:", updatedPatientKulawrutta); // Log the data to be updated

    //  const updatedData = {
    //   ...patientData,
    //   patientKulawrutta: [{ ...updatedPatientKulawrutta }] // Overwrite patientInfo while keeping other data unchanged
    // };

    // const updatedData = {
    //   ...patientData,
    //   patientKulawrutta: patientData.patientKulawrutta.map(info => ({
    //       ...info, // Keep existing patientInfo fields
    //       ...updatedPatientKulawrutta // Merge updated fields
    //   }))
    // };

    // const updatedData = {
    //   ...patientData,
    //   patientKulawrutta: patientData.patientKulawrutta.length > 0
    //       ? patientData.patientKulawrutta.map(info => ({
    //           ...info, // Keep existing patientInfo fields
    //           ...updatedPatientKulawrutta // Merge updated fields
    //       }))
    //       : [updatedPatientKulawrutta] // If empty, create a new array with updatedPatientKulawrutta
    // };

    const updatedData = {
      ...patientData,
      patientKulawrutta:
        patientData?.patientKulawrutta?.length > 0
          ? patientData.patientKulawrutta.map((info) => ({
              ...info, // Keep existing patientInfo fields
              ...updatedPatientKulawrutta, // Merge updated fields
              PATIENT_ID: patientData.PATIENT_ID,
              CASE_ID: selectedCase || caseId, // Add CASE_ID if missing
              //          VISIT_ID: selectedVisit || visitId  // Add VISIT_ID if missing
              DOCTOR_ID: doctorInfo.MANDALI_ID,
              CLINIC_ID: doctorInfo.CLINIC_ID, // Merge updated fields
            }))
          : [
              {
                ...updatedPatientKulawrutta,
                PATIENT_ID: patientData.PATIENT_ID,
                CASE_ID: selectedCase || caseId, // Default CASE_ID if not provided
                //         VISIT_ID: selectedVisit || visitId // Default VISIT_ID if not provided
                DOCTOR_ID: doctorInfo.MANDALI_ID,
                CLINIC_ID: doctorInfo.CLINIC_ID, // Merge updated fields
              },
            ],
    };

    setPatientData(updatedData);
    markSectionComplete("kulawrutta");
    if (location.pathname.startsWith("/addpatient")) {
      navigate("/addpatient/tapasanya");
    } else if (location.pathname.startsWith("/visits")) {
      navigate(`/visits/${patientId}/${caseId}/${visitId}/tapasanya`);
    } else {
      console.warn("Unknown route, no redirection");
    }
  };

  // Return student form
  return (
    <div>
      {patientData && (
        <PatientKulawruttaForm
          initialValues={patientData}
          onSubmit={onSubmitHandler}
          enableReinitialize={true}
        >
          Update Patient
        </PatientKulawruttaForm>
      )}
    </div>
  );
};

export default EditPatientKulawrutta;
